import { ImageLibrarySource } from './types';
import type { ImageLibraryKindFilter } from './useImageLibraryQuery';

export const ALL_IMAGE_SOURCES = 'all';

const LIBRARY_FILES_FILTER = 'files';

/** Sentinel for the rail's "no folder at all" filter, which is a filter rather than a folder name. */
export const UNFILED_FOLDER = '__unfiled__';

/** Shared by the picker tab and the library manager so a new source only has to be added once. */
const IMAGE_SOURCE_FILTERS = [
	{ value: ALL_IMAGE_SOURCES, label: 'All' },
	{ value: ImageLibrarySource.Upload, label: 'Uploaded' },
	{ value: ImageLibrarySource.Stock, label: 'Stock' },
	{ value: ImageLibrarySource.AIGenerated, label: 'AI' },
];

const FILES_FILTER = { value: LIBRARY_FILES_FILTER, label: 'Files' };

/**
 * Files sit alongside the sources rather than in a control of their own: to someone browsing, "show me the
 * PDFs" is the same kind of question as "show me the stock photos", and two toggles for one narrowing
 * reads as more machinery than it is. Only surfaces that can render a document may offer it.
 */
export function getImageLibraryFilters(includeFiles: boolean) {
	return includeFiles ? [...IMAGE_SOURCE_FILTERS, FILES_FILTER] : IMAGE_SOURCE_FILTERS;
}

export function toImageSourceFilter(value: string) {
	return value === ALL_IMAGE_SOURCES || value === LIBRARY_FILES_FILTER ? undefined : (value as ImageLibrarySource);
}

/**
 * `all` only where files are on offer. Everywhere else the absent filter has to stay images-only, which is
 * what keeps a PDF out of an image picker.
 */
export function toImageLibraryKindFilter(value: string, includeFiles: boolean): ImageLibraryKindFilter {
	if (!includeFiles) {
		return 'image';
	}

	return value === LIBRARY_FILES_FILTER ? 'document' : 'all';
}

/** Splits a rail selection into the two query parameters the listing and the keyword count both take. */
export function toFolderQueryParams(selectedFolder: string | null) {
	return {
		keyword: selectedFolder === UNFILED_FOLDER ? undefined : selectedFolder || undefined,
		unfiled: selectedFolder === UNFILED_FOLDER,
	};
}
